export { InfoModalContent } from "./InfoModalContent";
export type { InfoModalContentProps } from "./InfoModalContent";
